import { render, staticRenderFns } from "./VerifyRegister.vue?vue&type=template&id=c48aa4d6&scoped=true"
import script from "./VerifyRegister.vue?vue&type=script&lang=js"
export * from "./VerifyRegister.vue?vue&type=script&lang=js"
import style0 from "./VerifyRegister.vue?vue&type=style&index=0&id=c48aa4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48aa4d6",
  null
  
)

export default component.exports